import styled from 'styled-components';

const Container = styled.div`
  height: fit-content;
  display: flex;
  flex-direction: column;
  position: fixed;
  margin: ${(props) => props.margin};
  align-items: ${(props) => props.alignitem};
  text-align: ${(props) => props.textalign};
  right: ${(props) => props.right};
`;

Container.defaultProps = {
  margin: '50px 10% 0 20px',
  alignitem: 'center',
  textalign: 'center',
  right: '0',
};

export default Container;
